import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { Progress } from "@/components/ui/progress"
import { Zap, MapPin, Calendar, Wrench } from "lucide-react"

export default function Instalacoes() {
  const instalacoes = [
    {
      id: 1,
      projeto: "INS-2024-001",
      cliente: "João Silva",
      endereco: "Rua das Flores, 123 - São Paulo/SP",
      potencia: "8.5 kW",
      status: "Em Andamento",
      progresso: 65,
      dataInicio: "2024-01-20",
      previsaoTermino: "2024-02-10",
      responsavel: "Equipe Alpha"
    },
    {
      id: 2,
      projeto: "INS-2024-002",
      cliente: "Maria Santos",
      endereco: "Av. Paulista, 456 - São Paulo/SP",
      potencia: "12 kW",
      status: "Concluída",
      progresso: 100,
      dataInicio: "2024-01-05",
      previsaoTermino: "2024-01-25",
      responsavel: "Equipe Beta"
    },
    {
      id: 3,
      projeto: "INS-2024-003",
      cliente: "Carlos Ferreira",
      endereco: "Rua do Comércio, 789 - Campinas/SP",
      potencia: "9.5 kW",
      status: "Planejada",
      progresso: 10,
      dataInicio: "2024-02-01",
      previsaoTermino: "2024-02-20",
      responsavel: "Equipe Alpha"
    }
  ]

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Concluída": return "default"
      case "Em Andamento": return "secondary"
      case "Planejada": return "outline"
      default: return "secondary"
    }
  }

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Instalações</h1>
          <p className="text-muted-foreground">Acompanhamento de obras e instalações</p>
        </div>
        <Button className="gap-2">
          <Wrench className="h-4 w-4" />
          Nova Instalação
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Total Projetos</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{instalacoes.length}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Em Andamento</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-warning">
              {instalacoes.filter(i => i.status === "Em Andamento").length}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Concluídas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-success">
              {instalacoes.filter(i => i.status === "Concluída").length}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">kW Total</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {instalacoes.reduce((acc, i) => acc + parseFloat(i.potencia), 0).toFixed(1)} kW
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Zap className="h-5 w-5" />
            Projetos de Instalação
          </CardTitle>
          <CardDescription>
            Acompanhamento detalhado dos projetos
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {instalacoes.map((instalacao) => (
              <div key={instalacao.id} className="p-4 border border-border rounded-lg space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">{instalacao.projeto}</h3>
                    <p className="text-sm text-muted-foreground">Cliente: {instalacao.cliente}</p>
                  </div>
                  <Badge variant={getStatusColor(instalacao.status)}>
                    {instalacao.status}
                  </Badge>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4 text-muted-foreground" />
                    <span>{instalacao.endereco}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Zap className="h-4 w-4 text-muted-foreground" />
                    <span>Potência: {instalacao.potencia}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-muted-foreground" />
                    <span>Início: {new Date(instalacao.dataInicio).toLocaleDateString('pt-BR')}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-muted-foreground" />
                    <span>Previsão: {new Date(instalacao.previsaoTermino).toLocaleDateString('pt-BR')}</span>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="flex justify-between text-sm">
                    <span>Progresso da Instalação</span>
                    <span>{instalacao.progresso}%</span>
                  </div>
                  <Progress value={instalacao.progresso} className="h-2" />
                  <p className="text-xs text-muted-foreground">
                    Responsável: {instalacao.responsavel}
                  </p>
                </div>

                <div className="flex gap-2">
                  <Button variant="outline" size="sm">
                    Ver Detalhes
                  </Button>
                  <Button variant="outline" size="sm">
                    Fotos do Progresso
                  </Button>
                  <Button variant="outline" size="sm">
                    Atualizar Status
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
